import {MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType} from 'src_common/browser/apiUtils';

import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';
import { openapi_bonuses_putBonusesList, ParamsType, decodeResponse200, Response200Type } from 'src/api_openapi/generated/openapi_bonuses_putBonusesList';

export type WelcomeBonusModelType = Response200Type;

const decode = (status: number, data: ResponseType): WelcomeBonusModelType => {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface PromoNotificationsTypeSubmitType {
    data: ParamsType['requestBody'],
}

export const put_update_welcome_bonus = {
    browser: {
        params: (params: PromoNotificationsTypeSubmitType): ParamsFetchType<PromoNotificationsTypeSubmitType> => {
            return {
                type: MethodType.PUT,
                url: '/api-web/update_welcome_bonus',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.PUT,
        urlBrowser: '/api-web/update_welcome_bonus',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<PromoNotificationsTypeSubmitType>): Promise<GenerateUrlApiType> => {

        if (params.userSessionId === null) {
            return {
                passToBackend: false,
                status: 403,
                responseBody: {
                    errorMessage: 'User id invalid',
                }
            };
        }
        const response = await openapi_bonuses_putBonusesList(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
            requestBody: params.req.body.data
        });

        return {
            passToBackend: false,
            status: response.status,
            responseBody: response.body
        };
    }
};
